/**
 * Tymczasowe ograniczenie autouzupełniania / geokodu do Polski (mapa Odkryj — na razie tylko PL).
 *
 * - Ustaw na `''` aby wyłączyć parametr `countrycodes` w Nominatim (cały świat — wymaga zgodnego Edge).
 * - Gdy pojawią się inne kraje: np. `'pl,de'` (kody ISO 3166-1 alpha-2, przecinek bez spacji).
 *
 * @type {string}
 */
export const GEOCODE_NOMINATIM_COUNTRYCODES = 'pl';

/** Przy aktywnym GEOCODE — dodatkowy filtr współrzędnych (~bbox jak Photon PL w Edge). */
export const GEOCODE_POLAND_ROUGH_BBOX = Object.freeze({
  minLat: 49.0,
  maxLat: 55.3,
  minLon: 14.0,
  maxLon: 24.2,
});

export function isGeocodeCountryFilterActive() {
  return Boolean(String(GEOCODE_NOMINATIM_COUNTRYCODES || '').trim());
}

/**
 * @param {number|string} lat
 * @param {number|string} lon
 * @returns {boolean}
 */
export function isLatLngRoughlyInPoland(lat, lon) {
  const la = Number(lat);
  const lo = Number(lon);
  if (!Number.isFinite(la) || !Number.isFinite(lo)) return false;
  const { minLat, maxLat, minLon, maxLon } = GEOCODE_POLAND_ROUGH_BBOX;
  return la >= minLat && la <= maxLat && lo >= minLon && lo <= maxLon;
}
